export default "__VITE_ASSET__B34oUODM__"